module.exports = __webpack_public_path__ + "img/img (37).c88b627e.jpg";